import { useEffect, useRef, useState } from "react";
import VlRangeSelector from "../calendar/vl-range-selector";
import { useClickOutside } from "../../../hooks/useClickOutside";

import { useSelector, useDispatch } from "react-redux";
import { RootState, store } from "../../../store/store";
import { formatDate } from "../../../utils/formater";
import { setStartDate, setEndDate } from "../../../store/orm/userSession";
import ormStationsService from "../../../hooks/api/stations";

function Calendar(props: any) {
  const dispatch = useDispatch();

  const openingtimes = useSelector(
    (state: RootState) => state.stations?.openingtimes,
  );

  const [showCalendar, setShowCalendar] = useState<boolean>(props.show);

  const [changeDate, setChangeDate] = useState<"start" | "end" | null>("start");

  const startDate = useSelector(
    (state: RootState) => state.userSession.startDate,
  );
  const endDate = useSelector((state: RootState) => state.userSession.endDate);

  const [closedDays, setclosedDays] = useState<string[]>();
  const [closedStartDays, setclosedStartDays] = useState<string[]>();
  const [closedEndDays, setclosedEndDays] = useState<string[]>();

  const [minStartDate, setminStartDate] = useState<string>();
  const [minEndDate, setminEndDate] = useState<string>();
  const [maxStartDate, setmaxStartDate] = useState<string>();
  const [maxEndDate, setmaxEndDate] = useState<string>();

  useEffect(() => {
    setShowCalendar(props.show);
    setChangeDate(props.type);
  }, [props.show, props.type]);

  useEffect(() => {
    if (Object.keys(openingtimes).length > 0) {
      setminStartDate(formatDate(openingtimes.min_start_date));
      setminEndDate(formatDate(openingtimes.min_end_date));
      setmaxStartDate(formatDate(openingtimes.max_start_date));
      setmaxEndDate(formatDate(openingtimes.max_end_date));
      const closedDayArray = [] as any[];

      const closedDay = openingtimes.closed_days_config;
      if (openingtimes)
        closedDay.forEach((element: any) => {
          const date = element.date.split("T");
          const found = closedDayArray.find((element) => element === date[0]);
          if (!found) closedDayArray.push(date[0]);
        });

      setclosedDays(closedDayArray);

      const closedStartDayArray = [] as any[];

      const closedStartDay = openingtimes.start_closed_days_config;

      closedStartDay.forEach((element: any) => {
        const date = element.date.split("T");
        const found = closedStartDayArray.find(
          (element) => element === date[0],
        );
        if (!found) closedStartDayArray.push(date[0]);
      });

      setclosedStartDays(closedStartDayArray);

      const closedEndDayArray = [] as any[];

      const closedEndDay = openingtimes.end_closed_days_config;

      closedEndDay.forEach((element: any) => {
        const date = element.date.split("T");
        const found = closedEndDayArray.find((element) => element === date[0]);
        if (!found) closedEndDayArray.push(date[0]);
      });

      setclosedEndDays(closedEndDayArray);
    }
  }, [openingtimes]);

  // Callbacks
  const handleStartDateChange = (date: string | null) => {
    dispatch(setStartDate(date));
  };

  const handleEndDateChange = (date: string | null) => {
    dispatch(setEndDate(date));
  };

  const handleChangeDateChange = (value: "start" | "end" | null) => {
    if (!value) {
      props.onDone(true);
      ormStationsService.fetchOpeningTimes(store.getState().userSession);
    } else {
      setChangeDate(value);
      props.onTypeChange(value);
      ormStationsService.fetchOpeningTimes(store.getState().userSession);
    }
  };

  const handleFocus = (type: string | null = null) => {
    switch (type) {
      case "close":
        setShowCalendar(false);
        props.onDone(true);
        // console.log("Calendar focused", type);
        break;
      default:
        // console.log("Calendar focused", type);
        break;
    }
  };

  return (
    <div className="orm-calendar">
      {showCalendar ? (
        <VlRangeSelector
          startDate={startDate}
          endDate={endDate}
          changeDate={changeDate}
          minStartDate={minStartDate}
          minEndDate={minEndDate}
          maxStartDate={maxStartDate}
          maxEndDate={maxEndDate}
          defaultDate={startDate || undefined}
          disabledWeekdays={[]} // z.B. [0, 6] für Sonntag & Samstag
          disabledDates={closedDays}
          disabledStartDates={closedStartDays}
          disabledEndDates={closedEndDays}
          lang="DE"
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          onChangeDateChange={handleChangeDateChange}
          onFocus={handleFocus}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default Calendar;
